module.exports = __webpack_public_path__ + "assets/img/118@3x.a0cfa587.png";